var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { NoStyleButton } from '../../no-style-button.js';
import { cva } from 'class-variance-authority';
import { forwardRef } from 'react';
import { cn } from '../../cn.js';
import { Icon } from '../icon/icon.js';
import { addClassNameTo } from '../../add-classname-to.js';
const chipVariants = cva('group/chip inline-flex flex-row justify-center items-center text-onSurface border border-solid bg-surfaceContainer enabled:hover:bg-gradient-to-b from-neutral10/4 to-neutral10/4 enabled:active:bg-gradient-to-b active:from-neutral10/6 active:to-neutral10/6 disabled:text-onSurfaceDim disabled:border-outlineVariant disabled:bg-surfaceContainer', {
    variants: {
        size: {
            small: 'isSmall body1 h-400 min-w-1000 px-150 py-0 gap-50 rounded-500',
            large: 'isLarge body2 h-1000 px-300 py-200 gap-200 rounded-300',
        },
        selected: {
            false: 'border-outlineVariant active:border-outline',
            true: 'isSelected border-transparent bg-primaryContainer text-primary hover:border-transparent hover:bg-primaryContainer active:bg-primaryContainer',
        },
    },
    defaultVariants: {
        size: 'large',
        selected: false,
    },
});
export const ChipIcon = addClassNameTo(Icon, 'text-onSurfaceVariant group-[.isSelected]/chip:text-primary group-[.isSmall]/chip:w-250 group-[.isSmall]/chip:h-250 group-[.isSmall]/chip:text-[20px] group-[.isLarge]/chip:w-300 group-[.isLarge]/chip:h-300 group-[.isLarge]/chip:text-[24px] group-disabled/chip:text-onSurfaceDim');
/** Wayfinder chip */
export const Chip = forwardRef((_a, ref) => {
    var { size, selected, className } = _a, props = __rest(_a, ["size", "selected", "className"]);
    return _jsx(NoStyleButton, Object.assign({ ref: ref }, props, { className: cn(chipVariants({ size, selected, className })) }));
});
//# sourceMappingURL=chip.js.map